import PaymentImportPage from './PaymentImportPage';

export default PaymentImportPage;
